export interface PlatformFee {
  id: string;
  name: string;
  description: string;
  amount: number;
  active: boolean;
  planIds: string[];
  gracePeriodDays: number;
  autoSuspend: boolean;
  coverageItems: string[];
  suspensionConsequences: string[];
  createdAt: string;
  updatedAt: string;
}

export const platformFees: PlatformFee[] = [
  {
    id: 'fee_001',
    name: 'Licencia Anual de Frecuencia RFW',
    description: 'Licencia anual independiente del plan mensual que garantiza la reserva exclusiva de la frecuencia RFW asignada, el derecho de uso dentro de la plataforma RadioFrecuenciaWeb, inclusión en el directorio oficial, mantenimiento de la página pública, conservación de seguidores y comunidad, estadísticas e historial, acceso a actualizaciones y nuevas funcionalidades, acceso a mejoras de la aplicación móvil, mantenimiento operativo de la infraestructura, soporte técnico básico según plan contratado, y seguridad y monitoreo de la plataforma.',
    amount: 49.95,
    active: true,
    planIds: ['plan_001', 'plan_002', 'plan_003', 'plan_004', 'plan_005', 'plan_006'],
    gracePeriodDays: 30,
    autoSuspend: true,
    coverageItems: [
      'Reserva exclusiva de la frecuencia RFW asignada dentro del ecosistema RFW',
      'Derecho de uso de la frecuencia dentro de la plataforma y el dial digital',
      'Inclusión y permanencia en el directorio oficial de emisoras de RFW',
      'Mantenimiento de la página pública de perfil de la radio',
      'Conservación de seguidores y comunidad',
      'Conservación de estadísticas e historial',
      'Actualizaciones de la plataforma',
      'Nuevas funcionalidades incorporadas durante la vigencia',
      'Acceso a futuras mejoras de la aplicación móvil',
      'Mantenimiento operativo de la infraestructura',
      'Soporte técnico básico según el plan contratado',
      'Seguridad y monitoreo de la plataforma',
    ],
    suspensionConsequences: [
      'Suspensión temporal de la frecuencia',
      'Restricción de acceso a funciones premium',
      'Pérdida de la reserva exclusiva de la frecuencia',
      'Liberación de la frecuencia para futura asignación a terceros',
    ],
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2026-06-01T00:00:00Z',
  },
];

export const platformFeeHistory: {
  id: number;
  feeId: string;
  feeName: string;
  radioName: string;
  frequency: string;
  amount: number;
  status: 'paid' | 'pending' | 'grace' | 'suspended';
  dueDate: string;
  paidAt: string | null;
  graceUntil: string | null;
}[] = [
  { id: 1, feeId: 'fee_001', feeName: 'Licencia Anual de Frecuencia RFW', radioName: 'Radio Nueva Actitud', frequency: '87.90 RFW', amount: 49.95, status: 'paid', dueDate: '2026-03-15', paidAt: '2026-03-10', graceUntil: null },
  { id: 2, feeId: 'fee_001', feeName: 'Licencia Anual de Frecuencia RFW', radioName: 'Stereo Visión', frequency: '94.70 RFW', amount: 49.95, status: 'paid', dueDate: '2026-01-10', paidAt: '2026-01-05', graceUntil: null },
  { id: 3, feeId: 'fee_001', feeName: 'Licencia Anual de Frecuencia RFW', radioName: 'TechBeats', frequency: '88.50 RFW', amount: 49.95, status: 'pending', dueDate: '2026-07-20', paidAt: null, graceUntil: '2026-08-19' },
  { id: 4, feeId: 'fee_001', feeName: 'Licencia Anual de Frecuencia RFW', radioName: 'Radio Élite Digital', frequency: '91.30 RFW', amount: 49.95, status: 'grace', dueDate: '2026-05-01', paidAt: null, graceUntil: '2026-05-31' },
  { id: 5, feeId: 'fee_001', feeName: 'Licencia Anual de Frecuencia RFW', radioName: 'Radio Urbana 101', frequency: '103.50 RFW', amount: 49.95, status: 'paid', dueDate: '2026-04-01', paidAt: '2026-03-28', graceUntil: null },
  { id: 6, feeId: 'fee_001', feeName: 'Licencia Anual de Frecuencia RFW', radioName: 'Rock Total Radio', frequency: '87.01 RFW', amount: 49.95, status: 'paid', dueDate: '2026-04-10', paidAt: '2026-04-08', graceUntil: null },
  { id: 7, feeId: 'fee_001', feeName: 'Licencia Anual de Frecuencia RFW', radioName: 'Clásica Mundial Radio', frequency: '130.50 RFW', amount: 49.95, status: 'suspended', dueDate: '2026-02-28', paidAt: null, graceUntil: '2026-03-30' },
  { id: 8, feeId: 'fee_001', feeName: 'Licencia Anual de Frecuencia RFW', radioName: 'Radio Jazz Nocturno', frequency: '91.30 RFW', amount: 49.95, status: 'paid', dueDate: '2026-04-05', paidAt: '2026-04-01', graceUntil: null },
  { id: 9, feeId: 'fee_001', feeName: 'Licencia Anual de Frecuencia RFW', radioName: 'Radio Éxitos TV', frequency: '100.00 RFW', amount: 49.95, status: 'pending', dueDate: '2026-07-28', paidAt: null, graceUntil: '2026-08-27' },
  { id: 10, feeId: 'fee_001', feeName: 'Licencia Anual de Frecuencia RFW', radioName: 'Electro Vibes FM', frequency: '96.50 RFW', amount: 49.95, status: 'paid', dueDate: '2026-04-20', paidAt: '2026-04-15', graceUntil: null },
  { id: 11, feeId: 'fee_001', feeName: 'Licencia Anual de Frecuencia RFW', radioName: 'Deportes Total Radio', frequency: '120.00 RFW', amount: 49.95, status: 'suspended', dueDate: '2026-01-15', paidAt: null, graceUntil: '2026-02-14' },
  { id: 12, feeId: 'fee_001', feeName: 'Licencia Anual de Frecuencia RFW', radioName: 'Radio Hip Hop Nation', frequency: '170.40 RFW', amount: 49.95, status: 'pending', dueDate: '2026-07-11', paidAt: null, graceUntil: '2026-08-10' },
];

export const feeStatusLabels: Record<string, string> = {
  paid: 'Pagada',
  pending: 'Pendiente',
  grace: 'En Gracia',
  suspended: 'Suspendida',
};

export const feeStatusColors: Record<string, string> = {
  paid: 'bg-emerald-100 text-emerald-700',
  pending: 'bg-amber-100 text-amber-700',
  grace: 'bg-sky-100 text-sky-700',
  suspended: 'bg-red-100 text-red-600',
};

export const feeStatusIcons: Record<string, string> = {
  paid: 'ri-check-line',
  pending: 'ri-time-line',
  grace: 'ri-hourglass-line',
  suspended: 'ri-pause-circle-line',
};

export function getPlansAffectedLabel(planIds: string[]): string {
  if (planIds.length === 0 || planIds.length >= 6) return 'Todos los planes';
  return `${planIds.length} plan${planIds.length > 1 ? 'es' : ''}`;
}